/** The update state the UI shows (06 §15.3); no service-worker code, so any module may import it. */
import { signal } from '@preact/signals';

/** What the update UI shows. */
export const pwaState = signal<{ needRefresh: boolean; offlineReady: boolean }>({
  needRefresh: false,
  offlineReady: false,
});
